<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        v-if="initFilter == 'qualityNo'"
        :crumbs="[$t('menu.pengingQas'), $t('text.list')]"
      >
      </breadcrumb>

      <breadcrumb
        v-if="initFilter == 'storageNo'"
        :crumbs="[$t('menu.putins'), $t('text.list')]"
      >
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.materialSerialNo"
            :placeholder="$t('material.serialNoName')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky :sticky-top="50" :viewport="1024" :is-rem="false" class="sticky">
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button
              v-if="initFilter == 'qualityNo'"
              type="primary"
              size="mini"
              :loading="batchQualityDoing"
              @click="batchQuality"
              >{{ $t("action.quality") }}</el-button
            >

            <el-button
              v-if="initFilter == 'storageNo'"
              type="primary"
              size="mini"
              :loading="batchConfirmStorageDoing"
              @click="batchConfirmStorage"
              >{{ $t("action.confirmStorage") }}</el-button
            >
            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>

      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        :checkbox-config="{ reserve: true, checkMethod: checCheckboxMethod }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        :loading="loading"
        id="materialTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column field="checkbox" type="checkbox" width="35" />
        <vxe-table-column
          field="image"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.procureItem.image" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="procureItem.materialSerialNo"
          :title="$t('material.serialNo')"
          min-width="120"
        >
          <template v-slot="{ row }">
            {{ row.procureItem.materialSerialNo }}
            <div class="font10">
              {{ row.procureItem.materialName }}
              {{ row.procureItem.subjectName }}
            </div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="color"
          :title="$t('material.color')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.procureItem.color }}
            <div class="font10">{{ row.procureItem.colorNo }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="receiveAt"
          :title="$t('receive.receiveAt')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.receiveName }}
            <div class="font10">{{ row.receiveAt }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.procureItem.unit }}
            <div v-if="!row.isQuality" class="font10 grey-shallow">
              {{ $t("qualityInfosMms.notNeedQuality") }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="receiveWarehouseName"
          :title="$t('receive.receiveWarehouse')"
          min-width="100"
        />
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="80"
        />
        <vxe-table-column
          field="qualityAt"
          :title="$t('receive.qualityAt')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.qualityName }}
            <div class="font10">{{ row.qualityAt }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="qualityQuantity"
          :title="$t('receive.receivedQuantityMms')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span v-if="row.qualityQuantity != null">
              {{ row.qualityQuantity }}{{ row.procureItem.unit }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="returnAt"
          :title="$t('receive.returnAtMms')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.returnName }}
            <div class="font10">{{ row.returnAt }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="storageAt"
          :title="$t('receive.storageAtMms')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.storageName }}
            <div class="font10">{{ row.storageAt }}</div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="action"
          :title="$t('text.action')"
          width="110"
          fixed="right"
        >
          <template v-slot="{ row }">
            <el-button
              v-if="
                initFilter == 'qualityNo' &&
                canQuality(row) &&
                Permit.canActionsChargeEdition('mmsProcureQuality')
              "
              type="text"
              size="mini"
              @click="qualityRow(row)"
              >{{ $t("action.quality") }}</el-button
            >
            <el-button
              v-if="
                initFilter == 'qualityNo' &&
                canQuality(row) &&
                Permit.canActionsChargeEdition('mmsProcureQuality')
              "
              type="text"
              size="mini"
              :loading="returnDoing"
              @click="returnRow(row)"
              >{{ $t("action.returnMaterial") }}</el-button
            >
            <el-button
              v-if="
                initFilter == 'storageNo' &&
                canStorage(row) &&
                Permit.canActionsChargeEdition('mmsInventoryInOutManage')
              "
              type="text"
              size="mini"
              @click="confirmStorage(row)"
              >{{ $t("action.confirmStorage") }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <!-- 质检 -->
    <el-dialog
      :title="$t('action.quality')"
      :visible.sync="qualityRowDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form ref="qualityRowForm" :model="qualityRowObj" label-width="80px">
        <el-form-item
          :label="$t('receive.qualityQuantity')"
          :prop="'qualityQuantity'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('receive.qualityQuantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="qualityRowObj.qualityQuantity"
            :placeholder="qualityRowObj._maxQualityQuantity"
          >
            <template slot="append" v-if="row && row.procureItem">{{
              row.procureItem.unit
            }}</template>
          </el-input>
        </el-form-item>

        <el-form-item
          :prop="'receiveWarehouseId'"
          :label="$t('receive.receiveWarehouse')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('receive.receiveWarehouse')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model.trim="qualityRowObj.receiveWarehouseId"
            clearable
            filterable
          >
            <el-option
              v-for="warehouse in mmsAuthWarehouses"
              :key="warehouse.id"
              :label="warehouse.name"
              :value="warehouse.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="qualityRowDoing"
          size="small"
          @click="qualityRowSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="qualityRowDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 确认入仓 -->
    <el-dialog
      :title="$t('action.confirmStorage')"
      :visible.sync="confirmStorageDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form
        ref="confirmStorageForm"
        :model="confirmStorageObj"
        label-width="60px"
      >
        <el-form-item
          :label="$t('text.quantity')"
          :prop="'quantity'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.quantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="confirmStorageObj.quantity">
            <template slot="append" v-if="row && row.procureItem">{{
              row.procureItem.unit
            }}</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="confirmStorageSubmitDoing"
          size="small"
          @click="confirmStorageSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="confirmStorageDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import ReceiveMms from "@/api/receiveMms.js";
import Warehouse from "@/api/warehouse.js";
import UserWarehouse from "@/api/userWarehouse.js";

export default {
  mixins: [
    page,
    table.pager,
    table.search,
    table.narrow,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {},
  data() {
    return {
      Util: Util,

      narrows: [
        // [
        //   {
        //     label: this.$t("receive.qualityInfo"),
        //     items: [
        //       {
        //         label: this.$t("qualityInfosMms.unQuality"),
        //         key: "qualityNo",
        //         condition: { quality: "no", isQuality: "yes" },
        //       },
        //       {
        //         label: this.$t("qualityInfosMms.qualityPass"),
        //         key: "quality",
        //         condition: { quality: "quality", isQuality: "yes" },
        //       },
        //       {
        //         label: this.$t("qualityInfosMms.qualityReturn"),
        //         key: "retrunBack",
        //         condition: { quality: "retrunBack", isQuality: "yes" },
        //       },
        //       {
        //         label: this.$t("qualityInfosMms.notNeedQuality"),
        //         key: "notNeedQuality",
        //         condition: { isQuality: "no" },
        //       },
        //     ],
        //   },
        //   {
        //     label: this.$t("text.special"),
        //     items: [
        //       {
        //         label: this.$t("receive.storageNo"),
        //         key: "storageNo",
        //         condition: { storage: "no" },
        //       },
        //     ],
        //   },
        // ],
      ],
      initFilter: null,
      searchForm: {
        materialSerialNo: null,
      },
      sorter: {
        sortBy: "receives_id",
        sortIndicator: "desc",
      },
      warehouses: [],
      userWarehouses: [],
      mmsAuthWarehouses: [],

      // 质检
      qualityRowDF: false,
      row: { qualityShopId: null },
      qualityRowObj: {
        id: null,
        qualityQuantity: null,
        _maxQualityQuantity: null,
        receiveWarehouseId: null,
      },
      qualityRowDoing: false,
      //
      returnDoing: false,
      //确认入仓
      confirmStorageDF: false,
      confirmStorageSubmitDoing: false,
      confirmStorageObj: {
        quantity: null,
        _maxQuantity: null,
      },
      //
      batchQualityDoing: false,
      batchConfirmStorageDoing: false,
    };
  },

  created() {
    const self = this;
    if (window.location.href.indexOf("qas") != -1) {
      self.initFilter = "qualityNo";
      self.narrows.push([
        {
          label: this.$t("receive.qualityInfo"),
          items: [
            {
              label: this.$t("qualityInfosMms.unQuality"),
              key: "qualityNo",
              condition: { quality: "no", isQuality: "yes" },
            },
            {
              label: this.$t("qualityInfosMms.qualityPass"),
              key: "quality",
              condition: { quality: "quality", isQuality: "yes" },
            },
            {
              label: this.$t("qualityInfosMms.qualityReturn"),
              key: "retrunBack",
              condition: { quality: "retrunBack", isQuality: "yes" },
            },
            {
              label: this.$t("qualityInfosMms.notNeedQuality"),
              key: "notNeedQuality",
              condition: { isQuality: "no" },
            },
          ],
        },
      ]);
    }
    if (window.location.href.indexOf("putins") != -1) {
      self.initFilter = "storageNo";
      self.narrows.push([
        {
          label: this.$t("text.special"),
          items: [
            {
              label: this.$t("receive.storageNo"),
              key: "storageNo",
              condition: { storage: "no" },
            },
          ],
        },
      ]);
    }
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
  },
  methods: {
    getWarehouses() {
      const self = this;
      axios
        .all([
          Warehouse.findByTenantId(),
          UserWarehouse.findByUserId(self.Permit.currentUser().id),
        ])
        .then(
          axios.spread(function (warehouses, userWarehouses) {
            self.warehouses = warehouses.data;
            self.userWarehouses = userWarehouses.data;
            if (self.Permit.currentUser().admin) {
              self.mmsAuthWarehouses = self.warehouses;
            } else {
              const userWarehouseIds = self.userWarehouses.map(
                (u) => u.warehouseId
              );
              self.mmsAuthWarehouses = self.warehouses.filter((w) =>
                userWarehouseIds.includes(w.id)
              );
            }
          })
        );
    },

    // 批量入仓
    batchConfirmStorage() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message({
          message: self.$t("prompt.atLeastOneData"),
          type: "warning",
        });
        return;
      }
      const datas = self.selectRecords.map((c) => {
        return {
          id: c.id,
          quantity:
            c.isQuality && c.qualityAt !== null
              ? c.qualityQuantity
              : c.quantity,
        };
      });
      self.batchConfirmStorageDoing = true;
      ReceiveMms.batchConfirmStorage(datas).then(function (res) {
        if (res.status == 200) {
          self.batchConfirmStorageDoing = false;
          self.sysResults(res.data, self.$t("prompt.confirmStorageSuccess"));
          self.loadData();
          self.$eventHub.$emit("receiveMmsQualityBatch");
        } else {
          self.sysRrror();
        }
      });
    },

    // 确认入仓
    confirmStorage(row) {
      const self = this;
      self.row = row;
      if (row.isQuality) {
        self.confirmStorageObj.quantity = row.qualityQuantity;
        self.confirmStorageObj._maxQuantity = row.qualityQuantity;
      } else {
        self.confirmStorageObj.quantity = row.quantity;
        self.confirmStorageObj._maxQuantity = row.quantity;
      }
      self.confirmStorageDF = true;
      self.confirmStorageSubmitDoing = false;
    },
    confirmStorageSubmit() {
      const self = this;
      this.$refs.confirmStorageForm.validate((valid) => {
        if (valid) {
          if (
            !Util.regexQuantity(self.confirmStorageObj.quantity) ||
            self.confirmStorageObj.quantity == 0 ||
            self.confirmStorageObj.quantity == "0"
          ) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          // ||
          //   self.confirmStorageObj.quantity >
          //     self.confirmStorageObj._maxQuantity
          self.confirmStorageSubmitDoing = true;
          ReceiveMms.confirmStorage(self.row.id, self.confirmStorageObj).then(
            function (res) {
              if (res.status == 200) {
                self.confirmStorageSubmitDoing = false;
                self.confirmStorageDF = false;
                self.sysResult(res.data);
                self.loadData();
                self.$eventHub.$emit("receiveMmsConfirmStorage");
              } else {
                self.sysRrror();
              }
            }
          );
        } else {
          return false;
        }
      });
    },

    // 批量在质检
    batchQuality() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message({
          message: self.$t("prompt.atLeastOneData"),
          type: "warning",
        });
        return;
      }
      const datas = self.selectRecords.map((c) => {
        return {
          id: c.id,
          qualityQuantity: c.quantity,
          receiveWarehouseId: c.receiveWarehouseId,
        };
      });
      self.batchQualityDoing = true;
      ReceiveMms.batchQuality(datas).then(function (res) {
        if (res.status == 200) {
          self.batchQualityDoing = false;
          self.$message({
            message: self.$t("prompt.qualitySuccess"),
            type: "success",
          });
          self.loadData();
          self.$eventHub.$emit("receiveMmsQualityBatch");
        } else {
          self.sysRrror();
        }
      });
    },

    // 确认退料
    returnRow(row) {
      const self = this;
      self.returnDoing = true;
      ReceiveMms.return(row.id).then(function (res) {
        if (res.status == 200) {
          self.returnDoing = false;
          self.$message({
            message: self.$t("prompt.returnMaterialSuccess"),
            type: "success",
          });
          self.loadData();
          self.$eventHub.$emit("receiveMmsReturn");
        } else {
          self.sysRrror();
        }
      });
    },
    // 质检
    qualityRow(row) {
      this.row = row;
      this.getWarehouses();
      this.qualityRowObj.id = row.id;
      this.qualityRowObj.qualityQuantity = row.quantity;
      this.qualityRowObj._maxQualityQuantity = row.quantity;
      this.qualityRowObj.receiveWarehouseId = row.receiveWarehouseId;
      this.qualityRowDoing = false;
      this.qualityRowDF = true;
    },
    qualityRowSubmit() {
      const self = this;
      this.$refs.qualityRowForm.validate((valid) => {
        if (valid) {
          if (
            !Util.regexQuantity(self.qualityRowObj.qualityQuantity) ||
            this.qualityRowObj.qualityQuantity == 0 ||
            this.qualityRowObj.qualityQuantity == "0"
          ) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          //   this.qualityRowObj.qualityQuantity >
          // this.qualityRowObj._maxQualityQuantity
          this.qualityRowDoing = true;
          ReceiveMms.batchQuality([self.qualityRowObj]).then(function (res) {
            if (res.status == 200) {
              self.qualityRowDoing = false;
              self.qualityRowDF = false;
              self.$message({
                message: self.$t("prompt.qualitySuccess"),
                type: "success",
              });

              self.loadData();
              self.$eventHub.$emit("receiveMmsQualityBatch");
            } else {
              self.sysRrror();
            }
          });
        } else {
          return false;
        }
      });
    },
    //=====
    canQuality(row) {
      return row.isQuality && row.qualityAt == null && row.returnAt == null;
    },
    canStorage(row) {
      return (
        row.storageAt == null &&
        ((row.isQuality && row.qualityAt !== null) || !row.isQuality) &&
        row.returnAt == null
      );
    },

    // 可选
    checCheckboxMethod({ row }) {
      if (this.initFilter == "qualityNo") {
        return this.canQuality(row);
      }
      if (this.initFilter == "storageNo") {
        return this.canStorage(row);
      }
    },
    //
    dataProvider(params) {
      return ReceiveMms.search(params);
    },
  },
};
</script>
